module.exports = __webpack_public_path__ + "static/learncore-6fcdf450da9d47a568190fba1b261acc.jpg";